export const SECTIONS = [
  { title: "Products", url: "/products" },
  { title: "Contact", url: "/contact" },
];

export const TITLE = "Fake Shopping Website";
